export default deposit => deposit.subtype_description
